export const QUERY_KEYS = {
  chatId: "chaId",
  allChat: "allChat",
  getHoliday: "getHoliday"
} as const;
